import React from "react";
import { Modal, TouchableNativeFeedback, View, StyleSheet } from "react-native";
import CustomText from "@components/CustomText";
import InfoLines from "./InfoLines";

const InfoModal = (props) => {
  const { visible, info, onSubmit = () => {} } = props;

  return (
    <>
      <Modal
        statusBarTranslucent
        navigationBarTranslucent
        animationType="slide"
        transparent={true}
        visible={visible}
        onRequestClose={() => {
          console.log("Modal has been closed.");
        }}
      >
        <View style={styles.modalContainer}>
          <View style={styles.contentContainer}>
            <InfoLines info={info} />
            <View style={styles.buttonContainer}>
              <TouchableNativeFeedback
                testID="close"
                onPress={async () => onSubmit()}
              >
                <View style={styles.closeButton}>
                  <CustomText variant="title_16" style={styles.closeButtonText}>
                    ठीक है
                  </CustomText>
                </View>
              </TouchableNativeFeedback>
            </View>
          </View>
        </View>
      </Modal>
    </>
  );
};

const styles = StyleSheet.create({
  modalContainer: {
    backgroundColor: "rgba(0,0,0,0.7)",
    flex: 1,
    justifyContent: "center",
  },
  contentContainer: {
    backgroundColor: "rgba(255, 244, 233, 1)",
    borderRadius: 10,
    bottom: 200,
    paddingTop: 16,
    marginHorizontal: 8,
  },
  buttonContainer: {
    flexDirection: "row-reverse",
    marginLeft: 16,
    marginBottom: 16,
  },
  closeButton: {
    paddingHorizontal: 24,
    paddingVertical: 9,
    backgroundColor: "rgba(0, 171, 89, 1)",
    borderRadius: 8,
    marginTop: 16,
  },
  closeButtonText: {
    color: "white",
  },
});

export default InfoModal;
